import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6909aeea"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "background" }, null, -1))
const _hoisted_2 = { class: "text" }

import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  text: {
    type: String,
    required: true
  }
},
  setup(__props, { expose }) {

const props = __props



const root = ref(null)

expose({
  root
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: "temperature-indicator"
  }, [
    _hoisted_1,
    _createElementVNode("span", _hoisted_2, _toDisplayString(__props.text), 1)
  ], 512))
}
}

})